class AlertaHistoricoModal {
    $onInit() {
        this.alerta = this.resolve.alerta
    }

    getDescricaoStatus(status) {
        switch (status) {
            case 'REVISADO': return 'Revisado'
            case 'ANALISE': return 'Em análise'
            default: return 'Não revisado'
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('alertaHistoricoModal', {
        controller: [AlertaHistoricoModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal title="Histórico de revisão do alerta" close="$ctrl.close">
            <modal-body>
                <highlighted ng-hide="$ctrl.alerta.revisoes.length > 0">
                    <main>Não há histórico de revisão para este alerta.</main>
                    <secondary>
                        Aqui você poderá visualizar as marcações realizadas pelos usuários desta empresa
                        durante o processo de análise deste alerta.
                    </secondary>
                </highlighted>
                <table class="table table-stripped" ng-if="$ctrl.alerta.revisoes.length > 0">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Marcado como</th>
                            <th>Por</th>
                            <th>Em</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="revisao in $ctrl.alerta.revisoes">
                            <td>{{ $index + 1 }}</td>
                            <td><b>{{ $ctrl.getDescricaoStatus(revisao.status) }}</b></td> 
                            <td>{{ revisao.usuario.nome }}</td> 
                            <td><i>{{ revisao.insertedAt | date:'dd/MM/yyyy' }}</i> 
                                às <i>{{ revisao.insertedAt | date:'HH:mm' }}</i></td>
                        </tr>
                    </tbody>
                </table>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
